




































import Vue from 'vue';

export default Vue.extend({
  props: {
    type: {
      type: String,
      default: 'info',
    },
  },
  computed: {
    cssClass(): string {
      return `corems-shared-message--${this.type}`;
    },
  },
});
